import { PatchManagementSectionState } from './patch-management.types';
import { DataLoadedStatus, SectionStatusType } from '../../types';

export const defaultPatchManagementState: PatchManagementSectionState = {
  isValid: true,
  status: { type: SectionStatusType.NONE },
  summaryWindow: {
    isLoading: false,
    selectedWindowIds: [],
  },
  additionalInfo: {
    availableMaintenanceWindowsLoaded: DataLoadedStatus.NOT_LOADED,
  },
};
